import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import Navbar from "../components/navbar";
import Footer from "../components/footer";
import ScrollToTop from "../components/scroll-to-top";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useGetWishListItemsQuery, useSoftDeleteItemMutation } from "../redux/services/wishlist"; // Assuming you have a service to get wishlist items
import { useAddItemtoCartMutation } from "../redux/services/cart";
import { FiHeart } from "react-icons/fi";
import NoItemsFound from "../components/noItemsFound";

export default function Wishlist() {
  const user = useSelector((state) => state.auth.user);
  const navigate = useNavigate()
  const { data: wishlistItems, error, refetch: refetchWishlist } = useGetWishListItemsQuery({
    filter: {
      user_id: user.id,
      is_deleted: false
    }
  });
  const [softDeleteItem] = useSoftDeleteItemMutation();
  const [addProductToCart] = useAddItemtoCartMutation();

  const handleAddToCart = (item) => {
    addProductToCart({
      quantity: 1,
      product_id: item.id,
      user_id: user.id,
    });
    toast.success("Product added to cart!");
  };

  if (error) {
    return <div>Error loading wishlist items.</div>;
  }

  const RemoveFromWishlist = async (item) => {
    await softDeleteItem(item.id);
    toast.success("Product removed from wishlist!");
    refetchWishlist();
  };

  return (
    <>
      <Navbar navClass="defaultscroll is-sticky tagline-height" navlight={true} />

      <section className="relative table w-full items-center pt-36 pb-52 bg-orange-600 bg-[url('../../assets/images/hero/bg-shape.png')] bg-center bg-no-repeat bg-cover">
        <div className="container relative">
          <div className="grid grid-cols-1 text-center mt-10">
            <h3 className="md:text-7xl text-5xl md:leading-normal leading-normal tracking-wide font-bold uppercase text-white">Your Wishlist</h3>
          </div>
        </div>
      </section>

      <section className="relative md:py-24 py-16">
        <div className="container relative md:mt-24 mt-16">
          <div className="grid grid-cols-1 justify-center text-center mb-6">
            <h5 className="font-semibold text-3xl leading-normal mb-4">Your Favorite Items</h5>
            <p className="text-slate-400 max-w-xl mx-auto">Here are the items you have added to your wishlist.</p>
          </div>

          {!wishlistItems || wishlistItems.length === 0 ? (
            <NoItemsFound />
          ) : (
            <div className="grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 pt-6 gap-6">
              {wishlistItems?.map((item, index) => (
                <div className="group" key={index}>
                  <div className="relative overflow-hidden shadow dark:shadow-gray-800 group-hover:shadow-lg group-hover:dark:shadow-gray-800 rounded-md duration-500">
                    <img src={item?.product?.image_urls[0]} className="group-hover:scale-110 duration-500" alt="" />

                    <div className="absolute -bottom-20 group-hover:bottom-3 start-3 end-3 duration-500">
                      <button onClick={() => {
                        navigate(`/product-detail-three/${item.product_id}`);
                      }} className="py-2 px-5 inline-block font-semibold tracking-wide align-middle duration-500 text-base text-center bg-slate-900 text-white w-full rounded-md">View Details</button>
                    </div>

                    <button onClick={() => RemoveFromWishlist(item)} className="absolute top-[10px] end-4 opacity-0 group-hover:opacity-100 duration-500 size-10 inline-flex items-center justify-center tracking-wide align-middle text-center rounded-full bg-white text-orange-600 hover:bg-slate-900 hover:text-white shadow">
                      <FiHeart className="size-4" />
                    </button>
                  </div>

                  <div className="mt-4">
                    <Link to={`/product-detail-three/${item?.product?.id}`} className="hover:text-orange-500 text-lg font-medium">{item?.product?.title}</Link>
                    <div className="flex justify-between items-center mt-1">
                      <p>${item?.product?.price}</p>
                      {/* <ul className="font-medium text-amber-400 list-none">
                        <li className="inline"><i className="mdi mdi-star"></i></li>
                        <li className="inline"><i className="mdi mdi-star"></i></li>
                        <li className="inline"><i className="mdi mdi-star"></i></li>
                        <li className="inline"><i className="mdi mdi-star"></i></li>
                        <li className="inline"><i className="mdi mdi-star"></i></li>
                      </ul> */}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
      <Footer />
      <ScrollToTop />
    </>
  );
} 